/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";
import IconTextHeadingCard from "./sub-components/IconTextHeadingCard";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 8rem 0rem 8rem",
    },
    [theme.breakpoints.up("lg")]: {
      margin: "4rem 0rem 2rem 0rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 1rem 1rem 1rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      padding: "0rem",
    },
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#202020",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "2rem",

    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  column: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "1.5rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem",
      margin: "1rem 0rem 1rem 0rem",
    },
    [theme.breakpoints.only("sm")]: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "1rem",
      margin: "1rem 0rem 1rem 0rem",
      "& > *": {
        flex: "1 1 calc(50% - 1rem)",
        boxSizing: "border-box",
      },
    },
    [theme.breakpoints.only("lg")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "wrap",
      gap: "1.5rem",
      margin: "1rem 0rem 1rem 0rem",
    },
    "& > *": {
      flex: "1 1 calc(50% - 1.5rem)",
      boxSizing: "border-box",
    },
  },
  iconTextCard: {
    width: "100%",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    borderRadius: "1rem",
    border: "1px solid  rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    transition: "all 0.3s ease",
    [theme.breakpoints.up("md")]: {
      "&:hover": {
        borderColor: "#A8626C",
        backgroundColor: "#EEDFE2",
      },
    },
  },
  reraCard: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
    },
  },
  reraLink: {
    color: "#693471",
    textDecoration: "none",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  animatedCard: {
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    [theme.breakpoints.up("md")]: {
      "&:hover": {
        transform: "scale(1.05)",
      },
    },
  },
  reraLink: {
    color: "#a8626c",
    textDecoration: "none",
    display: "block",
  },
}));

const SpaciousSection = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      {/* <div className={classes.megaContainer}> */}
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="span"
            className={classes.heading}
          >
            Specifications
          </Typography>
          {/* <Typography
            variant="body1"
            component="span"
            className={classes.subHeading}
          >
            Super Built Up Area : 2065 Sqft - 2357 Sqft
          </Typography>
          <Typography
            variant="body1"
            component="a"
            href="https://rera.karnataka.gov.in/viewAllProjects"
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.subHeading} ${classes.reraLink}`}
          >
            PRM/KA/RERA/1251/310/PR/131224/007286
          </Typography> */}
          <div className={classes.column}>
            <IconTextHeadingCard
              className={`${classes.iconTextCard} ${classes.animatedCard}`}
              icon="/images/icons/heavie/halcyon/spaciouslayout.png"
              title="Spacious Layouts"
              description="Simplicity in form and function"
            />
            <IconTextHeadingCard
              className={`${classes.iconTextCard} ${classes.animatedCard}`}
              icon="/images/icons/heavie/halcyon/vaastu.png"
              title="Vaastu Compliance"
              description="Scientific and definitive design"
            />
            <IconTextHeadingCard
              className={`${classes.iconTextCard} ${classes.animatedCard}`}
              icon="/images/icons/heavie/halcyon/future_ready.png"
              title="Future Ready"
              description="Smart infrastructure for evolving lifestyles"
            />
            <IconTextHeadingCard
              className={`${classes.iconTextCard} ${classes.animatedCard}`}
              icon="/images/icons/heavie/halcyon/green_building.png"
              title="Green Building"
              description="IGBC certified sustainable structure"
            />
            <IconTextHeadingCard
              className={`${classes.iconTextCard} ${classes.animatedCard} ${classes.reraCard}`}
              icon="/images/icons/heavie/halcyon/rera.png"
              title="RERA No"
              description="PRM/KA/RERA/1251/310/PR/131224/007286"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SpaciousSection;
